import React from "react";

class MapTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.defaultactiveTab || "npi",
      startIndex: 0,
      visibleCount: 7, // default for desktop
      isMobile: false, // will update on mount
    };
  }

  options = [
    {
      label: "Overall Score",
      value: "npi",
      displayText: "Overall Score",
      urlText: "best-overall",
      iconBlack: "overall-grey.svg",
      iconWhite: "overall-white.svg",
    },
    {
      label: "School",
      value: "school",
      displayText: "School Score",
      urlText: "best-schools",
      iconBlack: "school-grey.svg",
      iconWhite: "school-white.svg",
    },
    {
      label: "Safety",
      value: "crime",
      displayText: "Safety Score",
      urlText: "best-safety",
      iconBlack: "safety-grey.svg",
      iconWhite: "safety-white.svg",
    },
    {
      label: "Amenities",
      value: "amenities",
      displayText: "Amenities Score",
      urlText: "best-amenities",
      iconBlack: "amenities-grey.svg",
      iconWhite: "amenities-white.svg",
    },
    {
      label: "Price",
      value: "medianprice",
      displayText: "Lowest Price",
      urlText: "best-medianprice",
      iconBlack: "price-grey.svg",
      iconWhite: "price-white.svg",
    },
    {
      label: "Value",
      value: "value",
      displayText: "Most Undervalued",
      urlText: "best-value",
      iconBlack: "undervalued-grey.svg",
      iconWhite: "undervalued-white.svg",
    },
    {
      label: "Appreciation",
      value: "appreciation",
      displayText: "Best Appreciation",
      urlText: "best-appreciation",
      iconBlack: "appreciation-grey.svg",
      iconWhite: "appreciation-white.svg",
    },
  ];

  componentDidMount() {
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
    this.setState({
      isMobile,
      visibleCount: isMobile ? 4 : this.options.length,
    });

    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.handleResize);
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  handleResize = () => {
    if (typeof window !== "undefined") {
      const isMobile = window.innerWidth < 768;
      this.setState({
        isMobile,
        visibleCount: isMobile ? 4 : this.options.length,
        startIndex: 0,
      });
    }
  };

  handleTabClick = (value, displayText, urlText) => {
    this.setState({ activeTab: value });
    this.props.onChange?.(value, displayText, urlText);
  };

  handleNext = () => {
    const { startIndex, visibleCount } = this.state;
    if (startIndex + visibleCount < this.options.length) {
      this.setState({ startIndex: startIndex + visibleCount });
    }
  };

  handlePrev = () => {
    const { startIndex, visibleCount } = this.state;
    if (startIndex - visibleCount >= 0) {
      this.setState({ startIndex: startIndex - visibleCount });
    }
  };

  render() {
    const { activeTab, startIndex, visibleCount, isMobile } = this.state;
    const visibleOptions = isMobile
      ? this.options.slice(startIndex, startIndex + visibleCount)
      : this.options;

    return (
      <div className="score-tabs-wrapper">
        {isMobile && startIndex > 0 && (
          <button className="arrow-button" onClick={this.handlePrev}>
            <i aria-hidden="true" class="angle left icon"></i>
          </button>
        )}

        <div className="score-tabs-container">
          {visibleOptions.map((item, index) => (
            <div
              key={item.value}
              className={`score-tab ${
                activeTab === item.value ? "active" : ""
              } ${index === 1 || index === 4 ? "ml-10" : ""}`}
              onClick={() =>
                this.handleTabClick(item.value, item.displayText, item.urlText)
              }
            >
              <p>
                <img
                  src={`${
                    process.env.NEXT_PUBLIC_CDN_ID
                  }static/images/factors/${
                    activeTab === item.value ? item.iconWhite : item.iconBlack
                  }`}
                  alt={
                    isMobile && item.value === "npi" ? "Overall" : item.label
                  }
                  className="tab-icon"
                />
              </p>
              <p>{isMobile && item.value === "npi" ? "Overall" : item.label}</p>
            </div>
          ))}
        </div>

        {isMobile && startIndex + visibleCount < this.options.length && (
          <button className="arrow-button" onClick={this.handleNext}>
            <i aria-hidden="true" class="angle right icon"></i>
          </button>
        )}
      </div>
    );
  }
}

export default MapTabs;
